/// <amd-module name="Repos/Views/CommitHub/Components/CommitLinksTab" />
import { MarkdownPreviewWithAutocomplete } from "Mention/MarkdownWithAutocomplete/Components";
import * as React from "react";
import { ICommitsTableProps } from "Repos/Common/Contracts/History";
import { previewOptions } from "Repos/Discussion/Utils/Markdown";
import { ICommitParent, ICommitViewService } from "Repos/Views/CommitHub/CommitViewService";
import * as Resources from "Repos/Views/CommitHub/Resources";
import { IReadonlyObservableArray } from "VSS/Core/Observable";
import { onClickFPS } from "VSS/Platform/FPS";
import { IVssComponentContext, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { Observer } from "VSSUI/Observer";
import { ITableRow } from "VSSUI/Table";
import { CommitActionsTable } from "./CommitActionsTable";
import { CommitDetailsExtensions } from "./CommitDetailsExtensions";
import { CommitPullRequestTable } from "./CommitPullRequestTable";
import { CommitTagsTable } from "./CommitTagsTable";
import { CommitPullRequest, CommitTag } from "Repos/Views/CommitHub/Contracts";

export class CommitLinksTab extends VssComponent<{}> {
    private commitViewService: ICommitViewService;
    private pullRequests: IReadonlyObservableArray<CommitPullRequest>;
    private tags: IReadonlyObservableArray<CommitTag>;
    private message: string;
    private parents: ICommitParent[];

    constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        this.commitViewService = context.pageContext.getService<ICommitViewService>("ICommitViewService");
        this.pullRequests = this.commitViewService.getPullRequests();

        this.tags = this.commitViewService.getTags();
        this.message = this.commitViewService.getCommitMessage();

        this.parents = this.commitViewService.getParents().filter(parent => !parent.isMergeSummary && !parent.isInitialCommit);
        this.commitViewService.loadParentCommitDetails();
    }

    public render() {
        return (
            <div className="rhythm-vertical-16">
                <Card titleProps={{ text: Resources.Description }}>
                    {MarkdownPreviewWithAutocomplete({ value: this.message, options: previewOptions })}
                </Card>
                <Card className="bolt-table-card" titleProps={{ text: Resources.Authorship }}>
                    <CommitActionsTable items={this.commitViewService.getRoleItems()} />
                </Card>
                {
                    (this.parents && this.parents.length > 0) &&
                    <Card className="bolt-table-card" titleProps={{ text: this.parents.length === 1 ? Resources.Parent : Resources.Parents }}>
                        <WrappedComponent<ICommitsTableProps>
                            wrappedType="repos-commits-table"
                            dependencies={["ms.vss-code-web.commits-list"]}
                            wrappedProps={{
                                commits: this.parents.map(p => p.commit)
                            }}
                        />
                    </Card>
                }
                <Observer pullRequests={this.pullRequests}>
                    {(props: { pullRequests: CommitPullRequest[] }) => {
                        return props.pullRequests && props.pullRequests.length > 0 ? (
                            <Card className="bolt-table-card" titleProps={{ text: Resources.PullRequests }}>
                                <CommitPullRequestTable items={this.pullRequests} onActivate={this.onPullRequestActivated} />
                            </Card>
                        ) : null;
                    }}
                </Observer>
                <Observer tags={this.tags}>
                    {(props: { tags: CommitTag[] }) => {
                        return props.tags && props.tags.length > 0 ? (
                            <Card className="bolt-table-card" titleProps={{ text: Resources.Tags }}>
                                <CommitTagsTable items={this.tags} onActivate={this.onTagActivated} />
                            </Card>
                        ) : null;
                    }}
                </Observer>
                <CommitDetailsExtensions />
            </div>
        );
    }

    private onPullRequestActivated = (event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<CommitPullRequest>) => {
        if (!event.defaultPrevented) {
            onClickFPS(this.context.pageContext, tableRow.data.linkProps.href!, true, event);
        }
    };

    private onTagActivated = (event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<CommitTag>) => {
        if (!event.defaultPrevented) {
            onClickFPS(this.context.pageContext, tableRow.data.linkProps.href!, true, event);
        }
    };
}
